export default __webpack_public_path__ + "static/media/greenPaddleBoardNFT.3a8f3164.png";